export default "__VITE_ASSET__CMrSxiCI__"